import { Dictionary } from "lodash";

export const API_URL = "/api/ServerResources/";

export function GetStrings(): Promise<Dictionary<string>> {
    return fetch(API_URL + "GetStrings").then(x => x.json());
}